import styled from 'styled-components';
import { Tooltip } from 'ui/tooltip';

export const StyledTooltip = styled(Tooltip)`
  width: 100%;
`;
